import React from 'react';
import PropTypes from 'prop-types';

import mixin from 'react-mixin';
import ScreenSizes from 'screen_sizes';

import { ModalActions } from 'realize/stores/modal_store';
import { Button } from 'realize/components/button'
import GridForm from 'realize/components/grid_form/grid_form';

import { FormEvents, FormEventHandler } from 'form/events/form_event_handler';
import TableCellRenderFactory from 'grid/table_cell_render_factory';

import InputGridFormFields from '../form/input_grid_form_fields';
import { GridFormActions, GridFormStore } from '../../reflux/grid_form_store';
import GridFormDefaultActions from '../../constants/grid_form_default_actions';
import GridFormActionIds from '../../constants/grid_form_action_ids';

import { connectToStore } from 'reflux/decorators/connect_to_store.js';
import { FormAPI } from 'lecom-api';

const RealizeTableRowActionButton = window.TableRowActionButton;

@connectToStore(GridFormStore, { storeIdProp: 'name' })
@mixin.decorate(window.CssClassMixin)
@mixin.decorate(window.InputComponentMixin)
export default class InputGridForm extends React.Component {
	static propTypes = {
		formId: PropTypes.number,
		label: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
		fields: PropTypes.array,
		form: PropTypes.object,
		clientSide: PropTypes.bool,
		clientSideIdField: PropTypes.string,
		inputWrapperComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.string]),
		onSuccess: PropTypes.func,
		onDestroySuccess: PropTypes.func,
		gridDataStoreRoute: PropTypes.object,
		isLoading: PropTypes.bool,
		actions: PropTypes.array,
	};

	static defaultProps = {
		clientSideIdField: 'id',
		themeClassKey: 'input.gridForm',
		className: '',
		fields: [],
		form: {},
		clientSide: true,
		inputWrapperComponent: null,
		waitForAction: false,
		gridDataStoreRoute: {},
		actions: GridFormDefaultActions,
		onSuccess: function() {},
		onDestroySuccess: function() {}
	};

	/* Lifecycle functions */

	constructor(props) {
		super(props);

		this.editAction = this.editAction.bind(this);
		this.handleFormSubmit = this.handleFormSubmit.bind(this);
		this.handleDestroyGridDataRow = this.handleDestroyGridDataRow.bind(this);
		this.handleGridReset = this.handleGridReset.bind(this);
	}

	componentDidMount() {
		if (!this.props.initialVisible) {
			this.getFieldAPI().initialVisible(true).apply();
			GridFormActions.loadInitialValues(undefined, this.props.originalId);
		}
		else {
			FormEventHandler.subscribe(FormEvents.INITIAL_VALUES_LOAD_SUCCESS, this.loadInitialValues.bind(this));
		}
	}

	loadInitialValues(eventName, formStoreId, response) {
		GridFormActions.loadInitialValues(response, this.props.originalId);
	}

	/* API functions */

	getFormAPI() {
		return FormAPI.form(this.props.formId);
	}

	getFieldAPI() {
		return this.getFormAPI().fields(this.props.id);
	}

	/* GridForm action handlers */

	editAction(event, dataRowId, dataRow) {
		event.preventDefault();

		if (window.innerWidth <= ScreenSizes.SMALL_SCREEN_WIDTH)
			ModalActions.open({ modalId: this.props.id + '-modal' });

		GridFormActions.editRow(this.props.id, dataRowId, dataRow);
	}

	/* Event handling functions */

	handleFormSubmit(event, postData) {
		event.preventDefault();

		const submittedDataRow = Object.assign({}, postData);
		GridFormActions.submitDataRow(this.props.name, submittedDataRow);
	}

	handleDestroyGridDataRow(event, id) {
		const fieldAPI = this.getFieldAPI();

		event.preventDefault();

		GridFormActions.removeDataRow(this.props.name, id);
		fieldAPI.publish(FormEvents.GRID_DESTROY, this.props.name, id);
	}

	handleGridReset(event) {
		GridFormActions.reset(this.props.id);
	}

	/* props parsers */

	wrapperClassName() {
		let className = this.className() + ' input-gridform__wrapper';
		let errors = this.props.errors[this.props.name];

		if (errors && Object.keys(errors).length)
			className += ' ' + Realize.themes.getCssClass('input.error');

		return className;
	}

	parseValueData() {
		let value = this.props.value;
		if(!value) {
			return {};
		}

		return {
			dataRows: value,
			count: value.length
		}
	}

	getDefaultFormProps() {
		return {
			formStyle: 'filter',
			inputWrapperComponent: this.props.inputWrapperComponent,
			label: this.props.label,
			createModalLabel: this.props.createModalLabel,
			editModalLabel: this.props.editModalLabel
		};
	}

	getColumnName(column, columnKey) {
		let columnName = column.name || columnKey;
		if (this.columnHaveDisplayValueKey(columnName))
			columnName += 'Display';

		return columnName;
	}

	parseFormProp() {
		return Object.assign({}, this.getDefaultFormProps(), this.props.form, {
			formId: this.props.formId,
			inputs: this.parseFieldsToInputs(),
		});
	}

	parseColumnsProp() {
		var columnsObject = { };

		for (let cont = 0, len = this.props.columns.length; cont < len; cont++) {
			let column = this.props.columns[cont];

			columnsObject[column.name] = Object.assign(column, {
				name: this.getColumnName(column, column.name),
				component: TableCellRenderFactory
			})
		}

		return columnsObject;
	}

	columnHaveDisplayValueKey(columnName) {
		const value = this.state.value;
		const firstValueRow = value == null ? null : value[0];

		if (firstValueRow == null) return false;

		const valueKeys = Object.keys(firstValueRow);
		return valueKeys.indexOf(`${columnName}Display`) >= 0;
	}

	isLoading() {
		return this.props.waitingForAction;
	}

	isFieldsEmpty() {
		return !this.props.fields || this.props.fields.length == 0;
	}

	parseFieldsToInputs() {
		var fields = { };
		for (let cont = 0, len = this.props.fields.length; cont < len; cont++) {
			let field = this.props.fields[cont];
			fields[field.name] = field;
		}
		return fields;
	}

	parseGridFormActionsProps() {
		return ({
			createButton: this.props.actions.find(a => a.id === GridFormActionIds.CREATE),
			updateButton: this.props.actions.find(a => a.id === GridFormActionIds.UPDATE),
			cancelButton: this.props.actions.find(a => a.id === GridFormActionIds.CANCEL),
			actionButtons: {  member: this.parseGridFormMemberActionsProps(this.props.actions), collection: [] },
		});
	}

	parseGridFormMemberActionsProps(actions) {
		var parseActions = actions
			.filter(action => action.gridActionType === 'member')
			.map(this.buildEditAction.bind(this));

		return parseActions;
	}

	buildEditAction(action) {
		return action.id === GridFormActionIds.EDIT
			? Object.assign({}, action, { onClick: this.editAction })
			: action;
	}

	renderGrid() {
		return (
			<div className={this.wrapperClassName()}>
				<GridForm
					{...this.propsWithoutCSS()}
					{...this.parseGridFormActionsProps()}
					isLoading={this.isLoading()}
					formComponent={InputGridFormFields}
					form={this.parseFormProp()}
					columns={this.parseColumnsProp()}
					onSubmit={this.handleFormSubmit}
					onDestroy={this.handleDestroyGridDataRow}
					onReset={this.handleGridReset}
					errors={this.props.errors}
					clientSideData={this.props.dataRows}
					clientSidePageCount={this.props.totalCount}
					initialValues={this.props.initialValues}
					data={this.parseValueData()}
					page={this.props.gridPage}
					perPage={this.props.gridPerPage}
					ref="gridForm" />
			</div>
		);
	}

	render() {
		return this.isFieldsEmpty() ? <span /> : this.renderGrid();
	}
}
